export const APP_TITLE_SUFFIX = 'Продажи Горько';

const SECTION_TITLES = {
	'/commission': 'Комиссионные',
	'/abonent': 'Абонентские',
	'/account-management': 'Аккаунт-менеджмент',
	'/content-management': 'Контент-менеджмент',
	'/calls': 'Звонки',
	'/objection': 'Возражения',
	'/worth': 'Оценка',
	'/no-access': 'Нет доступа',
};

export const formatDocumentTitle = (pageName) => {
	const name = String(pageName ?? '').trim();

	if (!name) return APP_TITLE_SUFFIX;

	return `${name} - ${APP_TITLE_SUFFIX}`;
};

export const getRoutePageTitle = ({ pathname = '', company = null } = {}) => {
	if (pathname.startsWith('/company/')) {
		return company?.name?.trim() || 'Компания';
	}

	const exact = SECTION_TITLES[pathname];

	if (exact) return exact;

	const sectionPath = Object.keys(SECTION_TITLES).find(
		(path) => path !== '/no-access' && pathname.startsWith(`${path}/`),
	);

	return sectionPath ? SECTION_TITLES[sectionPath] : null;
};
